/**
 * Dashboard — role-keyed entry point.
 *
 * Recruiter → RecruiterDashboard (recruiting KPIs + quick nav).
 * All other roles → HrFocusedDashboard (employees/probation/birthdays/docs).
 *
 * Foundation for per-role widget customisation: add new dashboard components
 * in ROLE_DASHBOARD_MAP as new roles need their own widget sets.
 */
import { useAuth } from '../contexts/AuthContext'
import HrFocusedDashboard from '../components/dashboard/HrFocusedDashboard'
import RecruiterDashboard from '../components/dashboard/RecruiterDashboard'

const ROLE_DASHBOARD_MAP = {
    recruiter: RecruiterDashboard,
}

export default function Dashboard() {
    const { user } = useAuth()
    const DashboardComponent = ROLE_DASHBOARD_MAP[user?.role] ?? HrFocusedDashboard
    return <DashboardComponent />
}
